export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/colourAdjustment.worker.eed535b2.worker.js");
}
